export const secondsToHumanReadableTime = (input: number): string => {
  const inputSeconds = Math.round(input)
  const hours = Math.floor(inputSeconds / (60 * 60))

  const divisor_for_minutes = inputSeconds % (60 * 60)
  const minutes = Math.floor(divisor_for_minutes / 60)

  const divisor_for_seconds = divisor_for_minutes % 60
  const seconds = Math.ceil(divisor_for_seconds)

  const timeParts: string[] = []
  const sections = {
    hour: hours,
    minute: minutes,
    second: seconds
  }

  Object.entries(sections).forEach(([name, value]) => {
    if (value > 0) {
      timeParts.push(`${value} ${name}${value === 1 ? '' : 's'}`)
    }
  })
  return timeParts.join(', ')
}
